












import { Component, Prop, Vue } from "vue-property-decorator";

@Component
class Button extends Vue {
  @Prop({ default: "primary" }) readonly color!: string;
}

export default Button;
